import { createContext } from "react";

const AppThemeContext = createContext({
	setTheme: (themeName: string) => {
		String(themeName);
	},
	setThemeSize: (size: string) => {
		String(size);
	},
	setThemeType: (type: string) => {
		String(type);
	},
	themeName: "worksuite",
	themeSize: "14",
	themeType: "light"
});

export default AppThemeContext;
